import { render, staticRenderFns } from "./SetupFirstPage.vue?vue&type=template&id=4e374ab8&scoped=true&"
import script from "./SetupFirstPage.vue?vue&type=script&lang=js&"
export * from "./SetupFirstPage.vue?vue&type=script&lang=js&"
import style0 from "./SetupFirstPage.vue?vue&type=style&index=0&id=4e374ab8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e374ab8",
  null
  
)

export default component.exports